import React, { useState, useEffect } from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import UserLeftPanel from "./include/LeftPanel";
import axios from "axios";
import Global from "../APIConfig";
import { ToastContainer, toast } from '../components/ui/toast';
import { useNavigate, useParams, Link } from "react-router-dom";
import MainLoader from "./Loaders/MainLoader";
import AuthUser from "../AuthUser";
import CopyToClipboard from 'react-copy-to-clipboard';
import { ArrowLeft, Plus, Copy, PencilLine, Trash2 } from "lucide-react";


function WarehouseList() {
    let navigate = useNavigate();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(true);
    const [list, setList] = useState([]);

    useEffect(() => {
        getWarehouseList();
    }, []);
    const items = JSON.parse(localStorage.getItem('user'));
    const getWarehouseList = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'WarehouseList',
            headers: headers1,
            data: {
                cust_id: items.uniqueid,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setList(data);
                }
                setLoading(false);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setLoading(false);
            });
    }
    const handleservicestatus = (id, val) => {
        if (window.confirm('Do you want to proceed?')) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'warehouseStatusupdate',
                headers: headers1,
                data: {
                    id: id,
                    status: val
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        getWarehouseList();
                        toast.success(response.data.message);
                    }
                    else {
                        toast.warn(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
        else {
            getWarehouseList();
        }
    }
    const handledeletelocation = (id) => {
        if (window.confirm('Do You  want to delete ?')) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'WarehouseDelete',
                headers: headers1,
                data: {
                    id: id
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                    }
                    else {
                        toast.warn(response.data.message);
                    }
                    getWarehouseList('');
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
        else {
            getWarehouseList('');
        }
    }

    return (
        <>
            <UserLeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                {Loading == true ? <MainLoader /> :
                    <div className="px-content">
                        <div className="px-pagehead">
                            <div className="px-pagehead__left">
                                <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                                    <ArrowLeft size={16} />
                                </button>
                                <h2 className="px-pagehead__title">Warehouse List</h2>
                            </div>
                            <div className="px-pagehead__actions">
                                <Link className="px-btn px-btn--primary" to="/WarehouseAdd">
                                    <Plus size={16} /> Add Warehouse
                                </Link>
                            </div>
                        </div>

                        <div className="px-table-wrap">
                            <table className="px-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Warehouse ID</th>
                                        <th>Warehouse Name</th>
                                        <th>Phone No.</th>
                                        <th>Address</th>
                                        <th>Active</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                {list.length > 0 ?
                                    <tbody>
                                        {list.map((ware, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <span className="px-awb">
                                                            <span className="px-mono">{ware.unique_id}</span>
                                                            <CopyToClipboard text={ware.unique_id} onCopy={() => { toast.success(ware.unique_id + ' Copied To Clipboard'); }}>
                                                                <button className="px-awb__copy" aria-label="Copy warehouse id"><Copy size={13} /></button>
                                                            </CopyToClipboard>
                                                        </span>
                                                    </td>
                                                    <td className="text-capitalize">{ware.warehouseName}</td>
                                                    <td>{ware.phone}</td>
                                                    <td className="text-capitalize">{ware.address} ,{ware.city} ,{ware.country}</td>
                                                    <td>
                                                        <label className="px-switch">
                                                            <input type="checkbox" checked={ware.active == 'Y' ? true : false}
                                                                onChange={() => { ware.active == 'Y' ? handleservicestatus(ware.id, 'N') : handleservicestatus(ware.id, 'Y') }} />
                                                            <span className="px-switch__slider"></span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <div className="px-row-actions">
                                                            <Link to={`/WarehouseEdit/${ware.unique_id}`} className="px-icon-btn" title="Edit Warehouse"><PencilLine size={15} /></Link>
                                                            <button className="px-icon-btn px-icon-btn--danger" onClick={() => handledeletelocation(ware.id)} title="Delete Warehouse"><Trash2 size={15} /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    :
                                    <tbody>
                                        <tr><td colSpan={7} className="px-table__empty">Record Not Found</td></tr>
                                    </tbody>
                                }
                            </table>
                        </div>
                    </div>
                }
                <Footer />
            </main>
        </>
    );
}
export default WarehouseList;
